<template>
    <div>
      <vs-prompt
      @cancel="closed"
      @close="closed"
      :buttons-hidden="true"
      :active.sync="dlgActive"
      :title="popupTitle"
      id="prompQrCodeScanner"
      style="z-index:30005">
       <div ref="barcode_container" id="barcode_container">
        <StreamBarcodeReader  ref="scanner" @decode="onQrDecoded" @loaded="onQrReaderLoaded"></StreamBarcodeReader>
       </div>
     </vs-prompt>
    </div>
</template>
<script>

import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
  name: "QrCodeScannerDlg",
  components: {
    StreamBarcodeReader
  },
  data: function (){
     return {
       dlgActive: false,
       show:true,
       error: "",
       scannerLoading:true,
       popupTitle: this.$t('COM.SCAN_BARCODE'),
       barcodereader:null
     }
  },
  methods:{
      
    showDlg(){
      this.dlgActive=true;
      this.$vs.loading();
       
    },
    closed(){
      this.stopCameraStream();
    },
    onQrDecoded(result){
      this.$emit('Scanned', result);
      this.stopCameraStream();
      this.dlgActive=false;
    },
    onQrReaderLoaded(){
      this.scannerLoading = false;
      this.$vs.loading.close();
    },
    stopCameraStream() {
      this.$refs.scanner.codeReader.stream.getTracks().forEach(function (track) { track.stop() });
    }
   
  },
  computed:{

  },
  watch:{
   
  }
};
</script>
<style>
div#prompQrCodeScanner > div.vs-dialog{
  max-width: 800px !important;
}
div#prompQrCodeScanner > div.vs-dialog > 
div.vs-dialog-text > div > div > 
div.vs-tabs > div.con-slot-tabs > div.vs-tabs--content{
min-height: 450px;
}
</style>